// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "bd64c11b8e74166c83b50abde59734cbba66ad12/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};